/*
  Modal "Dónde comprar" (snippets/tiendas-modal.liquid).

  En productos con enlaces a tiendas externas, el botón "Otros puntos de
  venta" lleva data-tiendas-modal-open="<id del dialog>" y abre el modal.
  El botón de añadir al carrito no se toca. Los eventos se delegan en
  document para que también funcione con formularios cargados por AJAX.
*/
(function() {
  if (window.tiendasModalInit) {
    return;
  }
  window.tiendasModalInit = true;

  var openClass = 'tiendas-modal-open';

  function openModal(opener) {
    var dialog = document.getElementById(opener.getAttribute('data-tiendas-modal-open'));

    if (!dialog || dialog.open) {
      return;
    }

    dialog.showModal();
    document.documentElement.classList.add(openClass);
  }

  document.addEventListener('click', function(evt) {
    var opener = evt.target.closest('[data-tiendas-modal-open]');

    if (opener) {
      evt.preventDefault();
      openModal(opener);
      return;
    }

    var dialog = evt.target.closest('dialog.tiendas-modal');

    if (!dialog) {
      return;
    }

    // Botón de cerrar o clic en el fondo (fuera de .tiendas-modal__inner)
    if (evt.target.closest('[data-tiendas-modal-close]') || evt.target === dialog) {
      dialog.close();
    }
  });

  // "close" no hace bubbling: se escucha en captura
  document.addEventListener('close', function(evt) {
    if (evt.target.classList && evt.target.classList.contains('tiendas-modal')) {
      document.documentElement.classList.remove(openClass);
    }
  }, true);
})();
